import React, { useEffect, useState, useRef } from 'react';

import {
  Button,
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { useTranslation } from 'react-i18next';

import { WysiwygField } from '../../../components';

import './style.scss';

const RECURRING_TYPE_MONTH = 'monthly';
const RECURRING_TYPE_SINGLE = 'single';

const ParagraphDonation = ({ id, entity, wide = false }) => {
  const { t } = useTranslation();
  const title = entity.getIn(['field_title', 0, 'value']);

  const body = entity.getIn(['field_body', 0, 'processed'], '');

  const SINGLE_AMOUNTS = [entity.getIn(['field_onetime_donation_1', 0, 'value'], 15), entity.getIn(['field_onetime_donation_2', 0, 'value'], 40), entity.getIn(['field_onetime_donation_3', 0, 'value'], 120)];
  const MONTHLY_AMOUNTS = [entity.getIn(['field_monthly_donation_1', 0, 'value'], 6), entity.getIn(['field_monthly_donation_2', 0, 'value'], 10), entity.getIn(['field_monthly_donation_3', 0, 'value'], 20)];

  const DEFAULT_AMOUNT = entity.getIn(['field_default_bedrag_single', 0, 'value'], 10);
  const DEFAULT_AMOUNT_MONTH = entity.getIn(['field_default_bedrag', 0, 'value'], 15);

  const link = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri'], 'https://actie.vluchtelingenwerk.nl/geef-voor-vluchtelingen'));
  const linkLabel = entity.getIn(['field_link', 0, 'title'], 'Vul overige gegevens in');

  const amountRef = useRef(null);

  const [recurring, setRecurring] = useState(RECURRING_TYPE_MONTH);
  const [amount, setAmount] = useState(DEFAULT_AMOUNT);

  // Render a field item
  const fieldItem = ({ active, onClick, label }) => {
    return (
      <div
        className={`ParagraphDonation__block__fields__item  ${active ? 'active' : ''}`}
        onClick={onClick}
      >
        {label}
      </div>
    );
  };

  // When amount selected
  const onAmountSelect = (val) => {
    setAmount(val);
    amountRef.current.value = '';
  };

  // On submit, redirect to actie. domain with current arguments
  const onSubmit = () => {
    const urlArgs = `t=${recurring === RECURRING_TYPE_SINGLE ? 'E' : 'M'}&a=${String(amount).replace('.', ',')}`;
    const url = `${link}?${urlArgs}`;

    window.location = url;
  };

  // Set the default amount when the recurring type changes.
  useEffect(() => {
    setAmount(recurring === RECURRING_TYPE_SINGLE ? DEFAULT_AMOUNT : DEFAULT_AMOUNT_MONTH);
  }, [recurring, setAmount, DEFAULT_AMOUNT, DEFAULT_AMOUNT_MONTH]);

  return (
    <Container id={id} className="Paragraph ParagraphDonation">
      <div className="row">
        <div className={`col-12 ${wide ? 'col-lg-12' : 'col-lg-5'}`}>
          <div className="ParagraphDonation__block">
            <div className="ParagraphDonation__block__title">
              <h2>{title}</h2>
            </div>
            <div className="ParagraphDonation__block__fields">
              <div className="ParagraphDonation__block__fields__heading">
                <h3>{t('general.donation_form.intro')}</h3>
              </div>
              <div className="ParagraphDonation__block__fields__type row">
                <div className="col-6">
                  {fieldItem({
                    active: recurring === RECURRING_TYPE_SINGLE,
                    onClick: () => {
                      setRecurring(RECURRING_TYPE_SINGLE);
                      onAmountSelect(SINGLE_AMOUNTS[0]);

                    },
                    label: t('general.donation_form.single'),
                  })}
                </div>
                <div className="col-6">
                  {fieldItem({
                    active: recurring === RECURRING_TYPE_MONTH,
                    onClick: () => {
                      setRecurring(RECURRING_TYPE_MONTH);
                      onAmountSelect(MONTHLY_AMOUNTS[0]);
                    },
                    label: t('general.donation_form.monthly'),
                  })}
                </div>
              </div>
              <div className="ParagraphDonation__block__fields__amount row">
                {recurring === RECURRING_TYPE_SINGLE ? (
                  <>
                    {SINGLE_AMOUNTS.map((samount) => {
                      return (
                        <div key={samount} className="col-4">
                          {fieldItem({ active: amount === samount, onClick: () => onAmountSelect(samount), label: `€${samount}` })}
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <>
                    {MONTHLY_AMOUNTS.map((samount) => {
                      return (
                        <div key={samount} className="col-4">
                          {fieldItem({ active: amount === samount, onClick: () => onAmountSelect(samount), label: `€${samount}` })}
                        </div>
                      );
                    })}
                  </>
                )}

              </div>
              <div className="ParagraphDonation__block__fields__other_amount">
                <input
                  type="text"
                  ref={amountRef}
                  min={0}
                  placeholder={t('general.donation_form.other_amount')}
                  onChange={(e) => {
                    let value = e.currentTarget.value;
                    // Apply correction for the euro sign.
                    if (value.substring(0, 1) === '€') {
                      value = value.replace(' ', '').slice(1);
                    }
                    // Replace comma's with periods for better usability.
                    value = value.replace(',', '.');
                    // Empty the field if not a number.
                    if (Number.isNaN(parseInt(value))) {
                      e.currentTarget.value = '';
                    } else {
                      // If the amount has decimals, max them to 2 decimals.
                      if (value.includes('.') && value.split('.')[1].length > 1) {
                        value = parseFloat(value).toFixed(2);
                      }
                      // Set the new value.
                      e.currentTarget.value = `€ ${value.replace('.', ',')}`;
                      setAmount(value);
                    }
                  }}
                />
              </div>
            </div>
            <div className="ParagraphDonation__block__submit">
              <Button className="Button--cta--dark Button--block" primary onClick={onSubmit}>
                <span>
                  {linkLabel}
                  <i className="icon icon-arrow-right icon-variant-1 ml-1" />
                </span>
              </Button>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 offset-lg-1 ParagraphDonation__body__wrapper">
          <WysiwygField
            property="schema:text"
            className="ParagraphDonation__body"
            html={body}
          />
        </div>
      </div>
    </Container>
  );
};

export default ParagraphDonation;
